var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "fragment",
    [
      _c(
        "b-dropdown",
        {
          ref: "emailActionsDropdown",
          staticClass: "mr-2 dropdown-responsive",
          attrs: { variant: "transparent", "no-caret": "" },
          on: { hide: _vm.hideDropdown },
          scopedSlots: _vm._u([
            {
              key: "button-content",
              fn: function () {
                return [
                  _c(
                    "div",
                    [
                      _c("icon", {
                        staticClass: "text-black",
                        attrs: { name: "cog" },
                      }),
                      _vm._v(" "),
                      _c("span", { staticStyle: { display: "none" } }, [
                        _vm._v("nodisplay"),
                      ]),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm._v(" "),
          !_vm.defaultAccount
            ? _c(
                "div",
                {
                  staticClass: "dropdown-item",
                  on: { click: _vm.updateDefaultEmail },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("global.actions.setAsPrimary")) +
                      "\n    "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dropdown-item",
              attrs: { role: "menuitem" },
              on: { click: _vm.showManageCalendarsModal },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("settings.accountTab.manageCalendars")) +
                  "\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "inline-prompt",
            {
              staticStyle: { "font-size": "0.8rem" },
              attrs: {
                id: "inline-prompt-" + _vm.accountId,
                disabled: _vm.disableDeleteEmail,
                loading: _vm.loading,
                "action-type": "delete",
                placement: "bottom",
                "confirmation-text":
                  "i18n|email.messages.removeEmailConfirmation",
              },
              on: {
                accept: _vm.deleteSyncedEmail,
                dismiss: _vm.inlinePromptHide,
                prompt: _vm.inlinePromptShown,
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "dropdown-item text-danger",
                  class: { disabled: _vm.disableDeleteEmail },
                  attrs: { role: "menuitem" },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("email.actions.deleteEmailSync")) +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "b-tooltip",
                {
                  attrs: {
                    target: "inline-prompt-" + _vm.accountId,
                    disabled: !_vm.disableDeleteEmail,
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("email.messages.disableDeleteEmail")) +
                      "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("manage-email-calendars-modal", {
        ref: "manageEmailCalendarsModal",
        attrs: { "selected-account-id": _vm.accountId },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }